import { HTTP } from "@/utils/http-common"
import { isNil } from "lodash"
export default {
  get: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/notes/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
